function classNames(...classes) {return classes.filter(Boolean).join(' ')}
export const PrimaryButtonXSmall = ({action, text, color}) => {
    return (
      <>
        <button
          type="button"
          onClick={action}
          className={classNames(`rounded ${color.background} px-2 py-1 text-xs font-semibold border-none ${color.text} shadow-sm hover:${color.backgroundHover} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`)}
        >
          {text}
        </button>
      </>
    )
}

export const PrimaryButtonSmall = ({action, text, color}) => {
    return (
      <>
        <button
          type="button"
          onClick={action}
          className={classNames(`rounded ${color.background} px-2 py-1 text-sm font-semibold border-none ${color.text} shadow-sm hover:${color.backgroundHover} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`)}
        >
          {text}
        </button>
      </>
    )
  }

export const PrimaryButtonMedium = ({action, text, color}) => {
  return (
    <>
      <button
        type="button"
        onClick={action}
        className={classNames(`rounded-md ${color.background} px-2.5 py-1.5 text-sm font-semibold border-none ${color.text} shadow-sm hover:${color.backgroundHover} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`)}
      >
        {text}
      </button>
    </>
  )
}

export const PrimaryButtonLarge = ({action, text, color}) => {
    return (
      <>
        <button
          type="button"
          onClick={action}
          className={classNames(`rounded-md ${color.background} px-3 py-2 text-sm font-semibold border-none ${color.text} shadow-sm hover:${color.backgroundHover} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`)}
        >
          {text}
        </button>
        </>
    )
}

export const PrimaryButtonXLarge = ({action, text, color}) => {
    return (
      <>
        <button
          type="button"
          onClick={action}
          className={classNames(`rounded-md ${color.background} px-3.5 py-2.5 text-sm font-semibold border-none ${color.text} shadow-sm hover:${color.backgroundHover} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`)}
        >
          {text}
        </button>
      </>
    )
  }